/**
 * Resolves the saved language on BOTH sides of the render.
 *
 * Server: reads the `truwe_lang` cookie from the incoming request, so the SSR
 * HTML is already in the visitor's chosen language — that is what removes the
 * flash of English for returning Hinglish users.
 * Client: reads the cookie / localStorage.
 *
 * No geo or Accept-Language sniffing. No saved choice means English.
 */

import { createIsomorphicFn } from "@tanstack/react-start";

import {
  DEFAULT_LANG,
  langFromCookieHeader,
  readSavedLang,
  type Lang,
} from "./config";

export const resolveLanguage = createIsomorphicFn()
  .server(async (): Promise<Lang> => {
    try {
      // Dynamic import keeps the server entry out of the client graph.
      const { getRequestHeader } = await import("@tanstack/react-start/server");
      return langFromCookieHeader(getRequestHeader("cookie")) ?? DEFAULT_LANG;
    } catch {
      return DEFAULT_LANG;
    }
  })
  .client(async (): Promise<Lang> => readSavedLang() ?? DEFAULT_LANG);
